<template>
  <div class="input-container">
    <legend>{{ legend }}</legend>

    <textarea class="input" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
      :placeholder="placeholder" :disabled="disabled" :readonly="readonly"></textarea>
  </div>
</template>

<script>

export default {
  name: 'Textarea',
  components: {},
  props: {
    legend: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    modelValue: {
      required: true,
    },
  },
  data() {
    return {
      isPasswordVisible: false,
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
    color: #606264;
  }

  .input {
    box-sizing: border-box;
    padding: 0.625rem;
    border: 1px solid #EAEAEA;
    border-radius: 4px;
    outline: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;

    &::placeholder {
      color: #D3D3D3;
    }

    &:disabled {
      cursor: not-allowed;
    }

    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px white inset !important;
      -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    }
  }

  .password-container {
    box-sizing: border-box;
    height: 2.7375rem;
    border: 1px solid #EAEAEA;
    border-radius: 4px;

    display: flex;
    align-items: center;

    .input {
      flex: 1;
      background: transparent;
      border: 0;
      outline: 0;
    }

    button {
      all: unset;
      padding-right: 0.625rem;
      cursor: pointer;
      color: #1C2D5A;
    }
  }
}
</style>